import { render, staticRenderFns } from "./deficiencia.vue?vue&type=template&id=650364cc"
import script from "./deficiencia.vue?vue&type=script&lang=js"
export * from "./deficiencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports